import React from "react";

import {
  AddressInput,
  Col,
  Input,
  Modal,
  Row,
  Typeahead,
  useFormValues,
} from "@administrate/piston-ux";
import { useTranslation } from "react-i18next";
import { AccountWithAncestors } from "../../components/Ancestors";
import { getEmptyPostalAddress, useCountryList } from "../../hooks/addresses";
import { AccountNode } from "../../types/LearnerManagement";

export const AddLearnerModal: React.FunctionComponent<
  React.PropsWithChildren<{
    onDone: Function;
    accountOptions: any;
  }>
> = ({ onDone, accountOptions }) => {
  const { t } = useTranslation();
  const { countryList } = useCountryList();
  const initialValues: any = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    account: null,
    jobTitle: "",
    postalAddress: getEmptyPostalAddress(),
  };

  const values = useFormValues(initialValues);
  return (
    <Modal
      show
      title={t("addLearner")}
      onDone={(submitted: boolean) => onDone(submitted, values)}
      values={values}
      primaryActionText={t("OK")}
      id="add-learner-modal"
    >
      <Row className="add-learner-modal">
        <Col md={6}>
          <Input
            name="firstName"
            label={t("firstName")}
            valid={(v) => (!!v ? true : `${t("firstNameIsRequired")}`)}
          />
        </Col>
        <Col md={6}>
          <Input
            name="lastName"
            label={t("lastName")}
            valid={(v) => (!!v ? true : `${t("lastNameIsRequired")}`)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Input name="jobRole" label={t("jobRole")} />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Input
            name="emailAddress"
            label={t("emailAddress")}
            valid={(v) => (!!v ? true : `${t("emailAddressIsRequired")}`)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <div className="account-hierarchy">
            <Typeahead
              label={t("account")}
              name="account"
              loadOptions={accountOptions}
              formatter={(coordinatorManagedAccounts: AccountNode) =>
                AccountWithAncestors(coordinatorManagedAccounts)
              }
              valid={(v) => (!!v ? true : `${t("accountIsRequired")}`)}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <AddressInput
            countryList={countryList}
            inputs={{
              line1: {
                name: "postalAddress.streetAddress1",
                required: false,
              },
              line2: {
                name: "postalAddress.streetAddress2",
                required: false,
              },
              line3: {
                name: "postalAddress.streetAddress3",
                required: false,
              },
              city: {
                name: "postalAddress.town",
                required: false,
              },
              postalCode: {
                name: "postalAddress.postcode",
                required: false,
              },
              province: {
                name: "postalAddress.province.code",
                required: false,
              },
              country: {
                name: "postalAddress.country.id",
                required: false,
              },
            }}
          />
        </Col>
      </Row>
    </Modal>
  );
};
